import { Browser, Device, Geo, Platform, Platforms } from "@identity/utils";
import { inject, singleton } from "tsyringe";
import { BrowserClient, Scope } from "@sentry/browser";

@singleton()
export class SentryContext {
  private tagsAlreadySet = false;

  constructor(
    @inject(Browser) private readonly browser: Browser,
    @inject(Device) private readonly device: Device,
    @inject(Platform) private readonly platform: Platform,
    @inject(Geo) private readonly geo: Geo,
  ) {}

  isSupported() {
    return [Platforms.FANDOMDESKTOP, Platforms.FANDOMMOBILE].includes(
      this.platform.get(),
    );
  }

  setTags(sentry: BrowserClient & Scope) {
    if (this.tagsAlreadySet) {
      return;
    }
    sentry.setTags({
      browser: this.browser.getBrowser(),
      device: this.device.getDeviceType(),
      platform: this.platform.get(),
      geo_country: this.geo.getCountryCode() ?? "",
      geo_continent: this.geo.getContinentCode() ?? "",
      geo_region: this.geo.getRegionCode() ?? "",
    });
    this.tagsAlreadySet = true;
  }
}
